// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_convertUnifiedProfileToIndividual(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "UnifiedProfileConversionCommitted",
    "UnifiedProfileConversionOutcomeUnknown",
    "UnifiedProfileNotUnifiedError",
    "UnifiedProfileUpdateFailed",
    "UpdateUnifiedAccountProfilePayload"
  ]);
}

let variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"convertUnifiedProfileToIndividual":{"u":"response_convertUnifiedProfileToIndividual"}}};

let wrapResponseConverterMap = {
  response_convertUnifiedProfileToIndividual: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"convertUnifiedProfileToIndividual":{"u":"response_convertUnifiedProfileToIndividual"}}};

let responseConverterMap = {
  response_convertUnifiedProfileToIndividual: unwrap_response_convertUnifiedProfileToIndividual
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": (v1/*: any*/),
  "type": "UnifiedProfileNotUnifiedError",
  "abstractKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": (v1/*: any*/),
  "type": "UnifiedProfileConversionCommitted",
  "abstractKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": (v1/*: any*/),
  "type": "UnifiedProfileConversionOutcomeUnknown",
  "abstractKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": (v1/*: any*/),
  "type": "UnifiedProfileUpdateFailed",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UnifiedProfileConversionConvertToIndividualMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "convertUnifiedProfileToIndividual",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v0/*: any*/)
            ],
            "type": "UpdateUnifiedAccountProfilePayload",
            "abstractKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "UnifiedProfileConversionConvertToIndividualMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "convertUnifiedProfileToIndividual",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "684d77b21b9cdf04b04ebc1244006ed0",
    "id": null,
    "metadata": {},
    "name": "UnifiedProfileConversionConvertToIndividualMutation",
    "operationKind": "mutation",
    "text": "mutation UnifiedProfileConversionConvertToIndividualMutation {\n  convertUnifiedProfileToIndividual {\n    __typename\n    ... on UpdateUnifiedAccountProfilePayload {\n      __typename\n    }\n    ... on UnifiedProfileNotUnifiedError {\n      message\n    }\n    ... on UnifiedProfileConversionCommitted {\n      message\n    }\n    ... on UnifiedProfileConversionOutcomeUnknown {\n      message\n    }\n    ... on UnifiedProfileUpdateFailed {\n      message\n    }\n  }\n}\n"
  }
};
})());

let wrap_response_convertUnifiedProfileToIndividual = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_convertUnifiedProfileToIndividual = unwrap_response_convertUnifiedProfileToIndividual;
exports.wrap_response_convertUnifiedProfileToIndividual = wrap_response_convertUnifiedProfileToIndividual;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
